module.exports = __webpack_public_path__ + "static/media/about-brain.64de7087.svg";